import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./feedScopeChip.module.css";

/**
 * The dismissible chip above the My Feed stream while a sidebar community is selected
 * (GROWTH-7130). Renders nothing for "All communities" (communityName is null/undefined).
 *
 * @param {Object} props
 * @param {string} [props.communityName]
 * @param {Function} props.onClear
 */
const FeedScopeChip = ({ communityName, onClear }) => {
  const { t } = useTranslation();

  if (!communityName) {
    return null;
  }

  return (
    <div className={styles.chip}>
      <span>{communityName}</span>
      <button type="button" className={styles.remove} aria-label={t("dashboard_feed_sidebar_clear_scope_aria")} onClick={onClear}>
        ×
      </button>
    </div>
  );
};

export default FeedScopeChip;
